// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingDot_loading__dhx5Z","circle":"LoadingDot_circle__36sy7","jump":"LoadingDot_jump__31KIk"};